var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.anfrage != undefined)?_c('div',{class:_vm.className},[_c('anfragen-anzeige-info',{model:{value:(_vm.anfrage),callback:function ($$v) {_vm.anfrage=$$v},expression:"anfrage"}}),_c('anfragen-anzeige-nachrichten',{model:{value:(_vm.anfrage),callback:function ($$v) {_vm.anfrage=$$v},expression:"anfrage"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }